import { Component, OnInit } from '@angular/core';
import { UserService } from '@delroydsouza/users';

@Component({
  selector: 'ngshop-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private usersService: UserService) {}
  title = 'ngshop';

  ngOnInit() {
    this.usersService.initAppSession();
  }
}
